import axios from 'axios';

const BASE_URL = 'https://admin.theholidaybasket.com/api'; 
// const BASE_URL = 'http://192.168.29.245:8000/api';

// Create axios instance
const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'x-api-key': 'uCTBVwReQNn7s9C3hU+RACTbVZImK2+xFWE8bmhX1iQITZcAw/kHUUJ1W6jFr1Ek',
    },
    withCredentials: false, // Disable sending credentials unless needed
});

// Generic API function
export const apiRequest = async ({ url, method = 'GET', data = null, params = {} }) => {
    try {
        const response = await api({ url, method, data, params });
        return response.data;
    } catch (error) {
        const err = error.response?.data || { message: 'Server error' };
        throw err;
    }
};
